import { render, staticRenderFns } from "./ContactsView.vue?vue&type=template&id=1277e59c&"
import script from "./ContactsView.vue?vue&type=script&scoped=true&lang=js&"
export * from "./ContactsView.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./ContactsView.vue?vue&type=style&index=0&id=1277e59c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports